import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"toolbar\" id=\"kt_toolbar\"><div id=\"kt_toolbar_container\" class=\"container-xxl d-flex flex-stack\"><div data-kt-swapper=\"true\" data-kt-swapper-mode=\"prepend\" data-kt-swapper-parent=\"{default: &#39;#kt_content_container&#39;, &#39;lg&#39;: &#39;#kt_toolbar_container&#39;}\" class=\"page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0\"><h1 class=\"d-flex align-items-center text-dark fw-bolder fs-3 my-1\"> Gender &amp; Policy </h1><span class=\"h-20px border-gray-200 border-start mx-4\"></span><ul class=\"breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1\"><li class=\"breadcrumb-item text-muted\"><a href=\"#\" class=\"text-muted text-hover-primary\"><h1 class=\"d-flex fw-bolder fs-3 my-1 text-muted\">Admin</h1></a></li><li class=\"breadcrumb-item\"><span class=\"bullet bg-gray-200 w-5px h-2px\"></span></li><li class=\"breadcrumb-item text-dark\"><h1 class=\"d-flex fw-bolder fs-3 my-1\">Ministry Wise Report</h1></li></ul></div></div></div>", 1)
const _hoisted_2 = { class: "card mt-10" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row mb-7" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Ministry", -1)
const _hoisted_7 = { class: "row mt-2" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Search", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "card mt-2" }
const _hoisted_12 = { class: "card-header border-0 pt-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, null, -1)
const _hoisted_14 = { class: "card-toolbar" }
const _hoisted_15 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_16 = { class: "ms-2 w-150px mr-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-excel" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-light" }, null, -1)
const _hoisted_19 = { class: "card-body pt-0" }
const _hoisted_20 = { class: "table-responsive" }
const _hoisted_21 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"},
  id: "kt_customers_table"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "bg-secondary",
    style: {"border":"1px solid #1db78d"}
  }, [
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Ministry"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "GST Activity"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Required Indicator"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Achievement (Reporting Period)"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Reporting Frequency"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Government Priority"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Submit Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Remarks"),
    /*#__PURE__*/_createElementVNode("th", { class: "" }, "Action")
  ])
], -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-light" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_GenderPolicyModal = _resolveComponent("GenderPolicyModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_select, {
              modelValue: _ctx.selectedMinistry,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMinistry) = $event)),
              class: "form-select-solid",
              placeholder: "Select Ministry",
              filterable: "",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  value: "",
                  selected: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Select Ministry...")
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ministryOptions, (option) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: option,
                    value: option,
                    label: option
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args))),
              class: "btn btn-sm btn-primary float-left",
              type: "button"
            }, _hoisted_10)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.exportType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.exportType) = $event)),
                id: "export",
                class: "form-select-solid",
                placeholder: "Select Export",
                filterable: "",
                onChange: _ctx.exportChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    value: "",
                    "aria-selected": ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Select Export")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_option, { value: "excel" }, {
                    default: _withCtx(() => [
                      _hoisted_17,
                      _createTextVNode(" Excel")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.create())),
              class: "btn btn-sm btn-primary",
              "data-kt-drawer-toggle": "true",
              "data-kt-drawer-target": "#store_gender_policy_drawer",
              id: "kt_drawer_gender_policy_list"
            }, [
              _hoisted_18,
              _createTextVNode(" Add Report ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("table", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderPolicyList, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  style: {"border":"1px solid #1db78d"},
                  key: item.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.ministry), 1),
                  _createElementVNode("td", null, _toDisplayString(item.gst_activity), 1),
                  _createElementVNode("td", null, _toDisplayString(item.required_indicator), 1),
                  _createElementVNode("td", null, _toDisplayString(item.achievement_reporting_period), 1),
                  _createElementVNode("td", null, _toDisplayString(item.reporting_frequency), 1),
                  _createElementVNode("td", null, _toDisplayString(item.government_priority ||
                  item.election_manifesto_target_aligned), 1),
                  _createElementVNode("td", null, _toDisplayString(item.submit_date), 1),
                  _createElementVNode("td", null, _toDisplayString(item.remarks), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.edit(item)),
                      "data-kt-drawer-toggle": "true",
                      "data-kt-drawer-target": "#store_gender_policy_drawer",
                      id: "kt_drawer_gender_policy_list",
                      class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                    }, _hoisted_25, 8, _hoisted_23),
                    _createElementVNode("button", {
                      title: "Delete",
                      type: "button",
                      onClick: ($event: any) => (_ctx.deleteReport(item.id)),
                      class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm me-1"
                    }, _hoisted_28, 8, _hoisted_26)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GenderPolicyModal, { data: _ctx.editData }, null, 8, ["data"])
  ], 64))
}